import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';
import { DialogRowRoot as Root } from "./styled";
export default function DialogRow(props) {
  return ___EmotionJSX(Root, props);
}
DialogRow.displayName = 'DialogRow';